import React, { HTMLAttributes, PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './PageContainer.module.scss';

type WrapperProps = HTMLAttributes<HTMLElement> & {
  isMain: boolean;
};

const Wrapper = ({
  isMain,
  children,
  ...rest
}: PropsWithChildren<WrapperProps>) =>
  isMain ? (
    <main id="main" tabIndex={-1} {...rest}>
      {children}
    </main>
  ) : (
    <div {...rest}>{children}</div>
  );

export type PageContainerProps = HTMLAttributes<HTMLElement> & {
  isMain?: boolean;
  hasContentPanel?: boolean;
};

export const PageContainer = ({
  children,
  isMain = true,
  hasContentPanel = true,
  className,
  ...rest
}: PropsWithChildren<PageContainerProps>) => {
  return (
    <Wrapper isMain={isMain} className={styles.pageContainer} {...rest}>
      <div
        className={classNames(hasContentPanel && styles.pageContent, className)}
      >
        {children}
      </div>
    </Wrapper>
  );
};
